module.exports = __webpack_public_path__ + "img/groundplan.49df070d.svg";